import { render } from "./Fitxa.vue?vue&type=template&id=869c30ac&scoped=true"
import script from "./Fitxa.vue?vue&type=script&lang=js"
export * from "./Fitxa.vue?vue&type=script&lang=js"

import "./Fitxa.vue?vue&type=style&index=0&id=869c30ac&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869c30ac"]])

export default __exports__